var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42897 8.43142C6.25303 8.05643 5.80641 7.89508 5.43142 8.07103C5.05643 8.24697 4.89508 8.69359 5.07103 9.06858L6.42897 8.43142ZM6.18373 9.67438L6.8627 9.3558L6.18373 9.67438ZM7.95638 9.74729L8.6069 10.1206L7.95638 9.74729ZM10.9005 6.12326C11.1067 5.76399 10.9825 5.30563 10.6233 5.09948C10.264 4.89333 9.80563 5.01747 9.59948 5.37674L10.9005 6.12326ZM8 14.5C4.41015 14.5 1.5 11.5899 1.5 8H0C0 12.4183 3.58172 16 8 16V14.5ZM14.5 8C14.5 11.5899 11.5899 14.5 8 14.5V16C12.4183 16 16 12.4183 16 8H14.5ZM8 1.5C11.5899 1.5 14.5 4.41015 14.5 8H16C16 3.58172 12.4183 0 8 0V1.5ZM8 0C3.58172 0 0 3.58172 0 8H1.5C1.5 4.41015 4.41015 1.5 8 1.5V0ZM5.07103 9.06858L5.50475 9.99296L6.8627 9.3558L6.42897 8.43142L5.07103 9.06858ZM8.6069 10.1206L10.9005 6.12326L9.59948 5.37674L7.30586 9.37403L8.6069 10.1206ZM5.50475 9.99296C6.10629 11.275 7.90211 11.3488 8.6069 10.1206L7.30586 9.37403C7.20518 9.5495 6.94864 9.53895 6.8627 9.3558L5.50475 9.99296Z",
    fill: "#7696F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCircleTick);
export default __webpack_public_path__ + "static/media/ic_circle-tick.b774e61e6456ec27dd490646ff9d2f1b.svg";
export { ForwardRef as ReactComponent };